module.exports = __webpack_public_path__ + "static/media/google.aacd52b1.png";